import {
  clientAuthorizedDelete,
  clientAuthorizedGet,
  clientAuthorizedPost,
} from 'utils/fetchUtils';
import { API_ROUTES } from 'utils/constants';

export interface CompanyApiKeyCreated {
  id: string;
  plainKey: string;
  keyPrefix: string;
  name: string | null;
  createdAt: string;
}

export interface CompanyApiKeyListItem {
  id: string;
  keyPrefix: string;
  name: string | null;
  createdAt: string;
  revokedAt: string | null;
}

export async function listCompanyApiKeys(
  companyId: string,
): Promise<CompanyApiKeyListItem[]> {
  return clientAuthorizedGet<CompanyApiKeyListItem[]>(
    API_ROUTES.COMPANY_API_KEYS,
    undefined,
    companyId,
  );
}

export async function createCompanyApiKey(
  companyId: string,
  name?: string,
): Promise<CompanyApiKeyCreated> {
  return clientAuthorizedPost<CompanyApiKeyCreated>(
    API_ROUTES.COMPANY_API_KEYS,
    name ? { name } : {},
    companyId,
  );
}

export async function revokeCompanyApiKey(
  companyId: string,
  id: string,
): Promise<void> {
  await clientAuthorizedDelete<unknown>(
    `${API_ROUTES.COMPANY_API_KEYS}/${encodeURIComponent(id)}`,
    undefined,
    companyId,
  );
}
